/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { challengeClipSchema } from './challenge-clip-schema';
import { challengeSchema } from './challenge-schema';
import { challengeTranslationSchema } from './challenge-translation-schema';

export const challengeWithMediaSchema = z.object({
  challenge: challengeSchema,
  clips: z.array(challengeClipSchema),
  translations: z.array(challengeTranslationSchema),
});

export type IChallengeWithMedia = z.infer<typeof challengeWithMediaSchema>;
